import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import {setFilterClick,setCardClickType} from "../../redux/actions/actionAction/ActionAction"
import { fetchUserMeetingList } from "../../redux/actions/meetingActions/MeetingAction";
import * as constantMessages from "../../constants/constatntMessages";
// FILTER COMPONENT
const ActionFilterComponent = React.memo((props) => {
  const dispatch = useDispatch();
  const delayStatusOptions = [
    {
      value: "DELAYED",
      label: "Delayed",
      name: "delayStatus",
    },
    {
      value: "NOTDELAYED",
      label: "Not Delayed",
      name: "delayStatus",
    },
  ];

  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const meetingData = useSelector((state) => state.meeting);
  const employeeData = useSelector((state) => state.user);
  const actionData = useSelector((state) => state.action);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedMeetingOption, setSelectedMeetingOption] = useState([
    { label: "Meeting Id", value: "" },
  ]);
  const [selectedStatusOption, setSelectedStatusOption] = useState([
    { label: "Select Status", value: "" },
  ]);
  const [selectedDelayStatusOption, setSelectedDelayStatusOption] = useState([
    { label: "Select Delay Status", value: "" },
  ]);

  const [selectedOwnerOption, setSelectedOwnerOption] = useState([
    { label: "Name", value: "" },
  ]);

  const [selectedAssigneeOption, setSelectedAssigneeOption] = useState([
    { label: "Name", value: "" },
  ]);
  const [errors, setErrors] = useState({});
  const [searchData, setSearchData] = useState({
    toDate: "",
    fromDate: "",
    meetingId: "",
    ownerId: "",
    actionStatus: "",
    delayStatus: "",
    assignedUserId: "",
  });

  useEffect(() => {
    setSearchData({
      ...props.initData,
    });
    dispatch(fetchUserMeetingList(userData?.organizationId, accessToken));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData({
      ...searchData,
      [name]: value,
    });
  };
  useEffect(() => {
    if (
      searchData.fromDate ||
      searchData.toDate ||
      searchData.ownerId ||
      searchData.meetingId ||
      searchData.actionStatus ||
      searchData.delayStatus ||
      searchData.assignedUserId
    ) {
      setIsDisabled(false);
    }
  }, [
    searchData.fromDate,
    searchData.toDate,
    searchData.meetingId,
    searchData.actionStatus,
    searchData.ownerId,
    searchData.delayStatus,
    searchData.assignedUserId,
  ]);
  useEffect(() => {
    setSearchData({
      toDate: "",
      fromDate: "",
      meetingId: "",
      ownerId: "",
      actionStatus: "",
      delayStatus: "",
      assignedUserId: "",
    });

    props.filterData({
      toDate: "",
      fromDate: "",
      meetingId: "",
      ownerId: "",
      actionStatus: "",
      delayStatus: "",
      assignedUserId: "",
      page: 1,
    });
    setSelectedAssigneeOption([{ label: "Name", value: "" }]);
    setSelectedOwnerOption([{ label: "Name", value: "" }]);
    setSelectedMeetingOption([{ label: "Meeting Id", value: "" }]);
    setSelectedStatusOption([{ label: "Select Status", value: "" }]);
    setSelectedDelayStatusOption([{ label: "Select Delay Status", value: "" }]);
  }, [props.taskViewClicked]);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!validateDates()) return;
  //   props.setfilter(false);
  //   props.filterData(searchData);
  //   setSearchData({
  //     ...searchData,
  //   });
  // };
  const handleSubmit = (e) => {
  e.preventDefault();
  if (!validateDates()) return;

  props.setfilter(false);

  // 👇 mark filter submit
  dispatch(setFilterClick(true));
 dispatch(setCardClickType(null));
  // trigger filter API call
  props.filterData(searchData);

  setSearchData({
    ...searchData,
  });
};

// const handleSubmit = (e) => {
//   e.preventDefault();
//   if (!validateDates()) return;
  
//   props.setfilter(false);

//   // Pass filterData with isFilterClick true
//   props.filterData({
//     ...searchData,
//     isFilterClick: true,
//   });

//   setSearchData({
//     ...searchData,
//     isFilterClick: true,  // keep it in state too if needed
//   });
// };
  const handleReset = (e) => {
    e.preventDefault(e);

    setSearchData({
      toDate: "",
      fromDate: "",
      meetingId: "",
      ownerId: "",
      actionStatus: "",
      delayStatus: "",
      assignedUserId: "",
    });

    props.filterData({
      toDate: "",
      fromDate: "",
      meetingId: "",
      ownerId: "",
      actionStatus: "",
      delayStatus: "",
      assignedUserId: "",
      page: 1,
    });
    setSelectedAssigneeOption([{ label: "Name", value: "" }]);
    setSelectedOwnerOption([{ label: "Name", value: "" }]);
    setSelectedMeetingOption([{ label: "Meeting Id", value: "" }]);
    setSelectedStatusOption([{ label: "Select Status", value: "" }]);
    setSelectedDelayStatusOption([{ label: "Select Delay Status", value: "" }]);
  };

  if (meetingData?.userMeetingList?.length !== 0) {
    var meetingIdOptions = meetingData?.userMeetingList?.map((meeting) => {
      const returnData = {
        value: meeting?._id,
        label: meeting?.meetingId,
        name: "meetingId",
      };

      return returnData;
    });
  }

  if (meetingData?.ownerList?.length !== 0) {
    var ownerOptions = meetingData?.ownerList?.map((user) => {
      const returnData = {
        value: user?._id,
        label: user.isEmployee
          ? `${user.name} / (${user.empId})`
          : `${user.name} / (${user.email})`,
        name: "ownerId",
      };

      return returnData;
    });
  }

  if (meetingData?.assigneeList?.length !== 0) {
    var assigneeOptions = meetingData?.assigneeList?.map((user) => {
      const returnData = {
        value: user?._id,
        label: user.isEmployee
          ? `${user.name} / (${user.empId})`
          : `${user.name} / (${user.email})`,
        name: "assignedUserId",
      };

      return returnData;
    });
  }

  let statusOptions = null;

  if (actionData.statusData?.length !== 0) {
    statusOptions = actionData.statusData?.map((status, index) => {
      let returnData = {
        value: status,
        label: status?.charAt(0).toUpperCase() + status.slice(1),
        name: "actionStatus",
      };

      if (status.toLowerCase() === "requestforreassign") {
        returnData.label = "Request For Forward";
      } else if (status.toLowerCase() === "notdelayed") {
        returnData.label = "Not Delayed";
      } else if (status.toLowerCase() === "reassigned") {
        returnData.label = "Forwarded";
      } else {
        returnData.label =
          status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
      }
      return returnData;
    });
  }

  const handleStatusChange = (e) => {
    const { name, value, label } = e;
    setSearchData({
      ...searchData,
      actionStatus: value,
    });
    setSelectedStatusOption(e);
  };

  const handleDelayStatusChange = (e) => {
    const { name, value, label } = e;
    setSearchData({
      ...searchData,
      delayStatus: value,
    });
    setSelectedDelayStatusOption(e);
  };

  const handleMeetingIdChange = (e) => {
    const { name, value } = e;
    setSearchData({
      ...searchData,
      [name]: value,
    });
    setSelectedMeetingOption(e);
  };
  const handleOwnerIdChange = (e) => {
    const { name, value } = e;
    setSearchData({
      ...searchData,
      [name]: value,
    });
    setSelectedOwnerOption(e);
  };

  const handleAssigneeIdChange = (e) => {
    const { name, value } = e;
    setSearchData({
      ...searchData,
      [name]: value,
    });
    setSelectedAssigneeOption(e);
  };
  const validateDates = () => {
    const errors = {};
    if (searchData.fromDate && searchData.toDate) {
      if (new Date(searchData.fromDate) > new Date(searchData.toDate)) {
        errors.fromDate = constantMessages.invalidFromDate;
      }
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <div
      className={props.filter ? "filter show" : "filter"}
      id="form-container"
    >
      <div className="filter-container">
        <h4 className="filterheading mb-0">Filter Actions</h4>
        <button
          type="button"
          onClick={(e) => props.setfilter(false)}
          style={{ border: "none", padding: 0, margin: 0 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </button>
      </div>

      <form id="myForm" onSubmit={handleSubmit} className="filter-form">
        <label htmlFor="from">From Date</label>
        <div className="from-to">
          <div
            className="relative w-100"
            onClick={() => document.getElementById("from").showPicker()}
          >
            <input
              className="filter-date"
              type="date"
              id="from"
              onChange={handleChange}
              name="fromDate"
              value={searchData.fromDate}
              onBlur={validateDates}
            />
          </div>
        </div>
        {errors.fromDate && (
          <span className="error-message">{errors.fromDate}</span>
        )}

        <label htmlFor="to">To Date</label>
        <div className="from-to">
          <div
            className="relative w-100"
            onClick={() => document.getElementById("todate").showPicker()}
          >
            <input
              className="filter-date"
              type="date"
              id="todate"
              onChange={handleChange}
              name="toDate"
              value={searchData.toDate}
              onBlur={validateDates}
            />
          </div>
        </div>

        <label>Filter By Meeting ID</label>

        <Select
          className="fltr-opt  z-index-high"
          placeholder="Select Meeting ID"
          name="meetingId"
          options={meetingIdOptions}
          onChange={handleMeetingIdChange}
          value={selectedMeetingOption}
        />

        <label>Filter By Owner</label>

        <Select
          className="fltr-opt"
          placeholder="Select Meeting ID"
          name="ownerId"
          options={ownerOptions}
          onChange={handleOwnerIdChange}
          value={selectedOwnerOption}
        />

        {!props.taskViewClicked &&
        (employeeData?.userData?.isMeetingOrganiser ||
          employeeData?.userData?.isAdmin) ? (
          <>
            <label>Filter By Assignee</label>
            <Select
              className="fltr-opt"
              placeholder="Select Assignee"
              name="assignedUserId"
              options={assigneeOptions}
              onChange={handleAssigneeIdChange}
              value={selectedAssigneeOption}
            />
          </>
        ) : null}

        <label>Filter By Status</label>

        <Select
          className="fltr-opt"
          placeholder="Select Status"
          name="actionStatus"
          options={statusOptions ? statusOptions : null}
          onChange={handleStatusChange}
          value={selectedStatusOption}
        />

        <label>Filter By Delay Status</label>

        <Select
          className="fltr-opt"
          placeholder="Select Delay Status"
          name="delayStatus"
          options={delayStatusOptions}
          onChange={handleDelayStatusChange}
          value={selectedDelayStatusOption}
        />

        <div className="mt-2 form-btm-btn">
          <button className="reset filter-height" type="reset" onClick={handleReset}>
            <p>Reset</p>
          </button>
          <button className="add-btn Mom-btn filter-height" disabled={isDisabled}>
            <p>Filter</p>
          </button>
        </div>
      </form>
    </div>
  );
});

export default ActionFilterComponent;
